import React from "react";
import "./CreateRoom.css";
import subjectImg1 from "../../assets/images/battlesubject.jpg";
import sideImg from "../../assets/images/g1.png";
import coinImg from "../../assets/images/coiin.png";

const CreateRoom = ({
  subjectName = "Current Affairs",
  subjectDescription = "Current Affairs is the study of recent national and international events",
  entryFee = 20,
  subjectImage,
  isLoading = false,
  isDisabled = false,
  onCreate,
}) => {
  return (
    <div className="create-room-ui">
      <div className="create-room-ui__illustration">
        <img src={sideImg} alt="" />
      </div>

      <div className="create-room-ui__content">
        <h2 className="create-room-ui__title">Create Room</h2>
        <div className="create-room-ui__title-line"></div>
        <p className="create-room-ui__subtitle">Create a private room for this subject</p>

        <div className="create-room-ui__subject">
          <div className="create-room-ui__subject-image">
            <div className="create-room-ui__subject">
              <img src={subjectImage || subjectImg1} alt="" />
            </div>
          </div>

          <div className="create-room-ui__subject-info">
            <h3>{subjectName}</h3>
            <p>{subjectDescription}</p>
          </div>

          <button type="button" className="create-room-ui__arrow" disabled>
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>

        <div className="create-room-ui__bottom">
          <div className="create-room-ui__entry-fee">
            <div className="create-room-ui__coin">
              <img src={coinImg} alt="" />
            </div>
            <span className="create-room-ui__fee-label">Entry Fee:</span>
            <span className="create-room-ui__fee-value">{entryFee} Coins</span>
          </div>

          <button
            type="button"
            className="create-room-ui__create-btn"
            onClick={onCreate}
            disabled={isLoading || isDisabled}
          >
            <span>{isLoading ? "Creating..." : "Create Room"}</span>
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateRoom;
